import React from "react";
import { FiCheck } from "react-icons/fi";
import { useAuth } from "../../context/auth-context";

type SuccessModalProps = {
  setResolveSuccessModal: (open: boolean) => void;
  setRefetchCounting: React.Dispatch<React.SetStateAction<number>>;
};

const SuccessModal = ({
  setResolveSuccessModal,
  setRefetchCounting,
}: SuccessModalProps) => {
  const { setUrlStatus } = useAuth();

  return (
    <div
      className="fixed inset-0 z-[150] flex items-center justify-center bg-black/70 p-4 backdrop-blur-[2px] font-manrope"
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="resolve-success-title"
        className="w-full max-w-sm rounded-2xl border border-[#2C363E] bg-[#13181B] p-8 text-center shadow-2xl"
      >
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500/15 ring-2 ring-emerald-500/40">
          <FiCheck className="text-3xl text-emerald-400" aria-hidden />
        </div>
        <h2
          id="resolve-success-title"
          className="mt-5 font-sora text-xl font-bold text-white"
        >
          Resolution submitted
        </h2>
        <p className="mt-2 text-[14px] leading-relaxed text-[#869AA9]">
          The selected payouts were processed successfully.
        </p>
        <button
          type="button"
          onClick={() => {
            setUrlStatus("");
            setRefetchCounting((prev) => prev + 1);
            setResolveSuccessModal(false);
          }}
          className="mt-8 w-full rounded-xl bg-secondary_button py-3.5 text-[14px] font-bold text-white transition hover:brightness-110"
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
